export const COLORS = {
  backgroundMain: '#f6f6f6',
  backgroundSecondary: '#f0f7f0',
  card: '#ffffff',
  primary: '#48984f',
  primaryDark: '#3d7d43',
  secondary: '#86b64a',
  line: '#dce8dc',
  textPrimary: '#243224',
  textSecondary: '#5b665b',
  placeholder: '#cdd6cd',
  receivedGreen: '#22c55e',
  receivedGreenBg: '#dcfce7',
  pendingYellow: '#eab308',
  pendingYellowBg: '#fef9c3',
  pendingYellowDark: '#a16207',
  extraOrange: '#ea580c',
  extraOrangeBg: '#ffedd5',
  extraOrangeDark: '#c2410c',
  subtotalBg: '#f0fdf4',
  subtotalGreenDark: '#166534'
};

export const TYPOGRAPHY = {
  fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
  title: { size: '32px', weight: 800, letterSpacing: '-0.5px', lineHeight: 1 },
  subtitle: { size: '18px', weight: 300, italic: true, lineHeight: 1.2 },
  sectionTitle: { size: '14px', weight: 700, letterSpacing: '1px' },
  label: { size: '11px', weight: 600, letterSpacing: '0.5px' },
  body: { size: '10px', weight: 400 },
  value: { size: '18px', weight: 700 },
  total: { size: '30px', weight: 800 }
};

export const RADIUS = {
  card: '8px',
  badge: '4px'
};

export const SIZES = {
  pageWidth: '210mm',
  margin: '20mm',
  columnGap: '6mm',
  headerHeight: '35mm',
  leftColumnWidth: '120mm',
  rightColumnWidth: '54mm',
  pageContentWidth: '170mm',
  tableHeaderPadding: '2.5mm 3mm',
  tableCellPadding: '2mm 3mm',
  badgePaddingH: '2mm',
  badgePaddingV: '1mm'
};

export const FONT_URL = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap';

export const PAGE_BREAK = {
  before: 'always',
  after: 'always',
  avoid: 'avoid'
};
